import { render } from "./SiteConfigForm.vue?vue&type=template&id=4770ecf7"
import script from "./SiteConfigForm.vue?vue&type=script&lang=js"
export * from "./SiteConfigForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__